import React from 'react';

/**
 * Rulers Overlay Component
 * Displays horizontal and vertical rulers with measurements
 */
const RulersOverlay = ({ 
    enabled, 
    color = '#94a3b8',
    width,
    height,
    unit = 'px',
    aspectRatio
}) => {
    if (!enabled) return null;

    const rulerSize = 24;
    const tickInterval = unit === 'px' ? 50 : 10;
    const smallTickInterval = unit === 'px' ? 10 : 2;

    const generateTicks = (length, isVertical = false) => {
        const ticks = [];
        const numTicks = Math.ceil(length / tickInterval);

        for (let i = 0; i <= numTicks; i++) {
            const position = i * tickInterval;
            if (position > length) break;

            // Major tick
            ticks.push(
                <g key={`major-${i}`}>
                    <line
                        x1={isVertical ? 0 : position}
                        y1={isVertical ? position : 0}
                        x2={isVertical ? rulerSize * 0.6 : position}
                        y2={isVertical ? position : rulerSize * 0.6}
                        stroke={color}
                        strokeWidth="1.5"
                    />
                    <text
                        x={isVertical ? rulerSize * 0.7 : position}
                        y={isVertical ? position + 4 : rulerSize * 0.8}
                        fill={color}
                        fontSize="9"
                        fontWeight="500"
                        textAnchor={isVertical ? 'start' : 'middle'}
                    >
                        {unit === 'px' ? position : `${(position / length * 100).toFixed(0)}%`}
                    </text>
                </g>
            );

            // Small ticks
            for (let j = 1; j < tickInterval / smallTickInterval; j++) {
                const smallPos = position + j * smallTickInterval;
                if (smallPos > length) break;

                ticks.push(
                    <line
                        key={`minor-${i}-${j}`}
                        x1={isVertical ? 0 : smallPos}
                        y1={isVertical ? smallPos : 0}
                        x2={isVertical ? rulerSize * 0.3 : smallPos}
                        y2={isVertical ? smallPos : rulerSize * 0.3}
                        stroke={color}
                        strokeWidth="1"
                        opacity="0.5"
                    />
                );
            }
        }

        return ticks;
    };

    return (
        <>
            {/* Horizontal Ruler */}
            <svg
                className="absolute left-0 pointer-events-none z-20"
                width={width}
                height={rulerSize}
                style={{ 
                    top: `-${rulerSize}px`,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderBottom: `1px solid ${color}`
                }}
            >
                {generateTicks(width, false)}
            </svg>

            {/* Vertical Ruler */}
            <svg
                className="absolute top-0 pointer-events-none z-20"
                width={rulerSize}
                height={height}
                style={{ 
                    left: `-${rulerSize}px`,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRight: `1px solid ${color}`
                }}
            >
                {generateTicks(height, true)}
            </svg>

            {/* Corner square */}
            <div
                className="absolute pointer-events-none z-20"
                style={{
                    top: `-${rulerSize}px`,
                    left: `-${rulerSize}px`,
                    width: rulerSize,
                    height: rulerSize,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderRight: `1px solid ${color}`,
                    borderBottom: `1px solid ${color}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <i className="bx bx-move text-gray-400 text-xs"></i>
            </div>
        </>
    );
};

export default RulersOverlay;
